import React from "react";
import HeaderCarousel from "./HeaderCarousel";

function Header() {
  return <HeaderCarousel />;
}

export default Header;
